import { Box } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import AnalyticsFilterCard from "./AnalyticsFilterCard";
import AnalyticsKpiCards from "./AnalyticsKpiCards";
import LeadsByDayChart from "./LeadsByDayChart";
import LeadsByBrandChart from "./LeadsByBrandChart";
import AnalyticsSkeleton from "./AnalyticsSkeleton";

interface AnalyticsProps {
  data: LeadsManagementData;
}

export default function Analytics({ data }: AnalyticsProps) {
  return (
    <Box sx={{ mt: 2 }}>
      <AnalyticsFilterCard data={data} />

      {data.isLoading ? (
        <AnalyticsSkeleton />
      ) : (
        <>
          <AnalyticsKpiCards data={data} />
          <LeadsByDayChart data={data} />
          <LeadsByBrandChart data={data} />
        </>
      )}
    </Box>
  );
}
